import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { getUrlParams, getGoqiiUserId } from "../apiService/timespam";
import { lifestyleApi } from "../apiService/api";
import DermaRangeSlider from "../Components/DermaRangeSlider";
import "./Theme.css";
import "./SkinMood.css";

const SkinMood = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { theme, lang } = getUrlParams();

  const urlParams = new URLSearchParams(window.location.search);
  const uuid = urlParams.get("uuid") || "";
  const goqiiUserId = getGoqiiUserId();
  const nonce = urlParams.get("nonce") || "";
  const apiKey = urlParams.get("apiKey") || "";
  const signature = urlParams.get("signature") || "";
  const goqiiAccessToken = urlParams.get("goqiiAccessToken") || "";

  const [itchingValue, setItchingValue] = useState(0);
  const [painValue, setPainValue] = useState(0);
  const [rednessValue, setRednessValue] = useState(0);
  const [sleepValue, setSleepValue] = useState(0);
  const [enabled, setEnabled] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    document.documentElement.className = theme === "dark" ? "dark" : "";
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
  }, [theme, lang]);

  useEffect(() => {
    setEnabled(itchingValue > 0 || painValue > 0 || rednessValue > 0 || sleepValue > 0);
  }, [itchingValue, painValue, rednessValue, sleepValue]);

  const handleLog = async () => {
    if (!enabled || loading) return;
    setLoading(true);
    try {
      await lifestyleApi.logSkinMood({ itchingValue, painValue, rednessValue, sleepValue });
    } catch (err) {
      console.error("logSkinMood:", err);
    } finally {
      setLoading(false);
    }
    const qs = `uuid=${uuid}&goqiiuserid=${goqiiUserId}&nonce=${nonce}&apiKey=${apiKey}&signature=${signature}&goqiiAccessToken=${goqiiAccessToken}&theme=${theme}&lang=${lang}`;
    navigate(`/skinmoodentry?${qs}`);
  };

  return (
    <>
      <section className="sm-page">
        <div className="sm-container">
          <div className="sm-question-block">
            <label className="sm-label">
              {t("skinMood.q1")}
            </label>
            <DermaRangeSlider handleValue={setItchingValue} />
          </div>

          <div className="sm-question-block">
            <label className="sm-label">
              {t("skinMood.q2")}
            </label>
            <DermaRangeSlider handleValue={setPainValue} />
          </div>

          <div className="sm-question-block">
            <label className="sm-label">
              {t("skinMood.q3")}
            </label>
            <DermaRangeSlider handleValue={setRednessValue} />
          </div>

          <div className="sm-question-block">
            <label className="sm-label">
              {t("skinMood.q4")}
            </label>
            <DermaRangeSlider handleValue={setSleepValue} />
          </div>
        </div>
      </section>

      <section className="sm-bottom-btn">
        <div className="sm-container">
          <button
            type="button"
            className="sm-btn-done"
            disabled={!enabled || loading}
            onClick={handleLog}
          >
            {loading ? t("skinMood.saving") : t("skinMood.done")}
          </button>
        </div>
      </section>
    </>
  );
};

export default SkinMood;
